<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
    >
        <circle cx="8.5" cy="5" r="1.5"/>
        <circle cx="15.5" cy="5" r="1.5"/>
        <circle cx="8.5" cy="12" r="1.5"/>
        <circle cx="15.5" cy="12" r="1.5"/>
        <circle cx="8.5" cy="19" r="1.5"/>
        <circle cx="15.5" cy="19" r="1.5"/>
    </svg>
</template>
